export const API_URL = "https://dashboard-api.mitranpack.com/api";
export const ACCESS_TOKEN = "accessToken";
export const ACCESS_NAME = "accessName";
export const ACCESS_MODE = "accessMode";
